// components/GuideCard.tsx
import { Info } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/card';

interface GuideCardProps {
  title: string;
  tips: string[];
  variant: 'green' | 'blue' | 'purple' | 'orange';
}

export const GuideCard = ({ title, tips, variant }: GuideCardProps) => {
  const styles = {
    green: 'bg-green-50 border-green-100 text-green-800',
    blue: 'bg-blue-50 border-blue-100 text-blue-800',
    purple: 'bg-purple-50 border-purple-100 text-purple-800',
    orange: 'bg-orange-50 border-orange-100 text-orange-800'
  };

  return (
    <Card className={styles[variant]}>
      <CardContent className="py-3">
        <div className="flex gap-2">
          <div className="mt-1">
            <Info className={`w-4 h-4`} />
          </div>
          <div>
            <div className="font-medium">{title}</div>
            <ul className="mt-2 space-y-1 text-sm">
              {tips.map((tip, index) => (
                <li key={index}>• {tip}</li>
              ))}
            </ul>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};